// Single source of truth for the site grid.
export const GRID_CLASSES = "grid px-6 md:px-20 3xl:px-60 grid-cols-6 md:grid-cols-12 gap-4 md:gap-6";